import { X } from "lucide-react";
import { DirectoryWizard } from "./DirectoryWizard";

// Popup wrapper so the same Company → Division → GST → Address → POC wizard can be
// opened from anywhere (e.g. the LR form) without leaving the current screen.
export function DirectoryWizardModal({ open, onClose, onChange }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-start justify-center overflow-y-auto py-8"
         data-testid="directory-wizard-modal" onClick={onClose}>
      <div className="w-full max-w-3xl mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-2">
          <div className="text-white font-semibold text-sm">Add to Company Directory</div>
          <button className="text-white/80 hover:text-white" onClick={onClose} data-testid="directory-wizard-modal-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <DirectoryWizard onChange={onChange} />
      </div>
    </div>
  );
}
